import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {InlineSVGModule} from 'ng-inline-svg-2';
import {ModalComponent} from './modal/modal.component';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from "../../../shared/shared.module";
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { SingletonConfirmationModalComponent } from './singleton-confirmation-modal/singleton-confirmation-modal.component';
import { MatIconModule } from '@angular/material/icon';
import { InformationModalComponent } from './information-modal/information-modal.component';
import { LeaveConfirmationModalComponent } from './leave-confirmation-modal/leave-confirmation-modal.component';

@NgModule({
  declarations: [
    ModalComponent,
    ConfirmationModalComponent,
    InformationModalComponent,
    SingletonConfirmationModalComponent,
    LeaveConfirmationModalComponent
  ],
  imports: [
    CommonModule,
    InlineSVGModule,
    RouterModule,
    NgbModalModule,
    SharedModule,
    MatIconModule
  ],
  exports: [
    ModalComponent,
    ConfirmationModalComponent,
    InformationModalComponent,
    SingletonConfirmationModalComponent,
    LeaveConfirmationModalComponent
  ],
})
export class ModalsModule {
}
